import React, { Component } from 'react'

export default class TargetWord extends Component {
    
  constructor(props) {
    super(props)
        this.onClickLetter = this.onClickLetter.bind(this)
        
    }

    onClickLetter(){
        if (this.props.onFocus!== undefined){
            this.props.onFocus();
        }
  }
  render() {
    const {word, hintLength,answer,isFocus, disabled, showCorrect} =  this.props;
     return word=== undefined ? (<div></div>):(
      <div className={`d-inline`}>{[...word].map((char,i)=>{

        let btnClassList = [];
        btnClassList.push('btn btn-word-letter rounded border-bottom-1 p-2 fw-bold');
        btnClassList.push(showCorrect?(char===answer[i]?'bg-success text-white ':' bg-danger text-white '):' bg-light');
        if (!showCorrect){
          btnClassList.push(i<hintLength?'text-muted ':'');
          btnClassList.push(isFocus? ' is-focus':'');
        }
       
        const btnText = showCorrect? char : (i<hintLength?char:(i<answer.length ? answer[i]:'_'));
        return <button disabled={disabled} key={`${word}-letter-${i}-${char}`} onClick={this.onClickLetter} 
       
        className={btnClassList.join(' ')}
        style={{marginLeft:'1px',color:(btnText==='_')?'transparent':'inherit'}}>
            {btnText}</button>
      })}</div>
    )
  }
}
